import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, addDoc } from 'firebase/firestore';
import { IoArrowBack, IoAddCircleOutline, IoInformationCircleOutline } from 'react-icons/io5';
import { useAuth } from '../context/AuthContext';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import SafeAreaInsets from '../components/Shared/SafeAreaInsets';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import './NuevaVisitaScreen.css'; // --- Premium CSS ---

function NuevaVisitaScreen() {
  const navigate = useNavigate();
  const { currentUser, isMoroso } = useAuth();

  const [parentesco, setParentesco] = useState('');
  const [nombres, setNombres] = useState('');
  const [apellidos, setApellidos] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validaciones
    if (!currentUser) {
      setError("Error: No se ha podido identificar al usuario.");
      return;
    }
    if (isMoroso) {
      setError("No puedes registrar visitas mientras tengas adeudos pendientes.");
      return;
    }

    if (!parentesco || !nombres || !apellidos) {
      setError('Todos los campos son obligatorios.');
      return;
    }
    setEnviando(true);

    try {
      const visitasRef = collection(db, 'visitasRecurrentes');
      await addDoc(visitasRef, {
        residenteId: currentUser.uid,
        parentesco: parentesco,
        nombres: nombres,
        apellidos: apellidos,
        nombreCompleto: `${nombres} ${apellidos}`,
        fotoUrl: '', // Placeholder logic
      });

      alert('¡Visita recurrente agregada!');
      navigate('/accesos/visitas');

    } catch (error) {
      console.error("Error al guardar visita: ", error);
      setError('Error al guardar la visita. Inténtalo de nuevo.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/accesos" />

      <main className="ks-main">
        <SafeAreaInsets top={false} bottom={true} />
        
        {/* Sticky Header unificado */}
        <div className="ks-header-sticky-wrapper">
          <KondoBrandHeader showBack={false} />
        </div>

        <div className="ks-scroll-area">
          <div className="new-visita-container">
            {/* Sticky Compact Header */}
            <div className="new-visita-fixed-wrapper">
              <div className="new-visita-banner-compact">
                <button type="button" onClick={() => navigate('/accesos/visitas')} className="new-back-btn glass" aria-label="Volver">
                  <IoArrowBack size={24} />
                </button>
                <div className="new-visita-banner-content">
                  <h2>Registrar Invitado</h2>
                  <p>Agrega familiares o amigos frecuentes</p>
                </div>
                <div className="new-visita-banner-icon">
                  <IoInformationCircleOutline />
                </div>
              </div>
            </div>

            <div className="new-visita-card">
              <div className="new-visita-info-box">
                <div className="info-icon-green"><IoInformationCircleOutline size={24} /></div>
                <div className="info-content">
                  <h4>Registro Rápido</h4>
                  <p>Las visitas registradas aquí quedarán guardadas en tu lista para generarles acceso rápido en el futuro.</p>
                </div>
              </div>

              <form onSubmit={handleSubmit} className="new-visita-grid">
                {error && <div className="error-msg">{error}</div>}
                {isMoroso && !error && (
                  <div className="error-msg">No puedes registrar nuevas visitas mientras tengas adeudos.</div>
                )}

                <div className="form-field full-width">
                  <label className="field-label">Parentesco / Relación</label>
                  <select value={parentesco} onChange={(e) => setParentesco(e.target.value)} className="field-select" required>
                    <option value="">Selecciona una opción...</option>
                    <option value="Familiar">Familiar</option>
                    <option value="Amistad">Amistad</option>
                    <option value="Servicio">Servicio / Trabajador</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>

                <div className="form-field">
                  <label className="field-label">Nombre(s)</label>
                  <input type="text" value={nombres} onChange={(e) => setNombres(e.target.value)} className="field-input" placeholder="Ej. Ana" required />
                </div>

                <div className="form-field">
                  <label className="field-label">Apellidos</label>
                  <input type="text" value={apellidos} onChange={(e) => setApellidos(e.target.value)} className="field-input" placeholder="Ej. López" required />
                </div>

                <button type="submit" className="btn-create" disabled={enviando || isMoroso}>
                  <IoAddCircleOutline size={24} />
                  {enviando ? 'Guardando...' : 'Agregar Visita Recurrente'}
                </button>
              </form>
            </div>
          </div>
        </div>

        <KondoBottomNav activeRoute="/accesos" />
      </main>
    </div>
  );
}

export default NuevaVisitaScreen;